// Serialises the shared administration list contract:
//   search, filters=[{field,type,value}], sort=[{field,type}], page, limit
// Field names are public response names; the backend whitelists them.

export type FilterOp = 'search' | 'contains' | 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte' | 'in' | 'not_in'
export type SortDirection = 'asc' | 'desc'

export type ListFilter = {
  field: string
  type: FilterOp
  /** Scalar condition. Multi-value `in`/`not_in` filters leave this absent. */
  value?: string | number | boolean
  /** Server-validated values for `in`/`not_in`. */
  values?: string[]
}
export type ListSort = { field: string; type: SortDirection }

export type ListQuery = {
  search?: string
  filters?: ListFilter[]
  sort?: ListSort[]
  page?: number
  limit?: number
  /** Single-purpose legacy parameters some endpoints still accept (status, branch_id, role_id…). */
  params?: Record<string, string | number | boolean | undefined>
}

export function toListParams(query: ListQuery = {}): Record<string, string | number | boolean> {
  const params: Record<string, string | number | boolean> = {}
  if (query.search?.trim()) params.search = query.search.trim()
  if (query.filters?.length) params.filters = JSON.stringify(query.filters)
  if (query.sort?.length) params.sort = JSON.stringify(query.sort)
  if (query.page) params.page = query.page
  if (query.limit) params.limit = query.limit
  for (const [key, value] of Object.entries(query.params ?? {})) {
    if (value !== undefined && value !== '') params[key] = value
  }
  return params
}
